import React from 'react';
import { createRoot } from 'react-dom/client';

import OrderFormModal from '@/components/Modals/OrderFormModal';
import type { OrderFormContent } from '@/components/Forms/OrderForm';

interface InitOrderFormModalOptions {
  root: string;
  button: string;
  content: OrderFormContent;
  modal?: unknown;
}

const initOrderFormModal = (options: InitOrderFormModalOptions, onSuccess?: () => void): void => {
  const container = document.getElementById(options.root);

  if (!container) {
    return;
  }

  // eslint-disable-next-line no-underscore-dangle
  const { recaptchaSiteKey, recaptchaDisabled } = window.__config__;

  const root = createRoot(container);

  root.render(
    <OrderFormModal
      recaptchaSiteKey={recaptchaSiteKey}
      recaptchaDisabled={recaptchaDisabled}
      button={options.button}
      content={options.content}
      onSuccess={onSuccess}
    />
  );
};

export default initOrderFormModal;
